/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import globalStyles from '../styles';

const styles = () => ({
    table: {
        maxWidth: '500px',
        margin: '0 auto'
    },
    subheading: {
        margin: '20px 0 10px'
    },
    tripLine: {
        border: '1px solid #ccc',
        borderRadius: 5,
        marginBottom: 5,
        textAlign: 'left',
        padding: 5,
        display: 'flex'
    },
    tripLineActive: {
        border: '1px solid #5dcaff',
        cursor: 'pointer'
    },
    tripLineHead: {
        display: 'flex',
        borderRight: '1px solid #ccc',
        paddingRight: 5,
        marginRight: 5,
        textAlign: 'center',
        width: 55,
        justifyContent: 'center'
    },
    tripDate: {
        fontWeight: 'bold'
    },
    tripDateDay: {
        fontSize: 20,
        display: 'block',
        color: '#5dcaff'
    },
    tripDateMonth: {
        fontSize: 8,
        display: 'block'
    },
    tripService: {
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        flexDirection: 'column',
        flexGrow: 1
    },
    tripStop: {
        fontSize: '0.8em',
        color: '#666',
        display: 'flex',
        alignItems: 'center'
    },
    tripChange: {
        display: 'flex',
        alignItems: 'end',
        justifyContent: 'center',
        flexDirection: 'column',
        color: '#03a9f4',
        fontSize: '0.8em',
        borderLeft: '1px solid #ccc',
        paddingLeft: 5,
        marginLeft: 5
    },
    icon: {
        fontSize: '15px'
    },
    link: globalStyles.link,
    changeIcon: {
        fontSize: 20,
        color: '#5dcaff'
    }
});

const extractTime = dateService => {
    return dateService.substring(15, 19);
};

const extractDate = dateService => {
    return dateService.substring(2, 12);
};

const BookingTable = ({ bookings, classes }) => {
    if (!bookings || !bookings.length) {
        return (
            <>
                <p>
                    <strong>No trips booked</strong>
                </p>
                <p>We{"'"}ll display all your bookings here for your records</p>
            </>
        );
    }

    const history = useHistory();

    const today = moment().format('YYYY-MM-DD');

    const previousBookings = bookings.filter(booking => {
        return extractDate(booking.date_svc) < today;
    });

    const currentBookings = bookings.filter(booking => {
        return extractDate(booking.date_svc) >= today;
    });

    if (currentBookings) {
        currentBookings.reverse();
    }

    return (
        <>
            {currentBookings && currentBookings.length > 0 && (
                <>
                    <h2>Upcoming trips</h2>
                    {currentBookings.map(trip => (
                        <div
                            className={`${classes.tripLine} ${
                                trip.is_swappable ? classes.tripLineActive : ''
                            }`}
                            onClick={() => {
                                if (!trip.is_swappable) {
                                    return;
                                }
                                history.push(
                                    `/booking/${encodeURIComponent(
                                        trip.pk
                                    )}/${encodeURIComponent(trip.sk)}`
                                );
                            }}
                        >
                            <div className={classes.tripLineHead}>
                                <div className={classes.tripDate}>
                                    <span className={classes.tripDateDay}>
                                        {moment(extractDate(trip.date_svc))
                                            .format('ddd')
                                            .toUpperCase()}
                                    </span>
                                    <span className={classes.tripDateMonth}>
                                        {moment(extractDate(trip.date_svc))
                                            .format('Do MMM')
                                            .toUpperCase()}
                                    </span>
                                </div>
                            </div>
                            <div className={classes.tripService}>
                                {extractTime(trip.date_svc)} | {trip.s_name}
                                <div className={classes.tripStop}>
                                    <span className={classes.tripStopLabel}>
                                        {'stop' in trip && <>{trip.stop} </>}
                                    </span>
                                </div>
                            </div>
                            {trip.is_swappable && (
                                <div className={classes.tripChange}>EDIT</div>
                            )}
                        </div>
                    ))}
                </>
            )}
            {previousBookings && previousBookings.length > 0 && (
                <>
                    <h2>Previous trips</h2>
                    {previousBookings.map(trip => (
                        <div className={classes.tripLine}>
                            <div className={classes.tripLineHead}>
                                <div className={classes.tripDate}>
                                    <span className={classes.tripDateDay}>
                                        {moment(extractDate(trip.date_svc))
                                            .format('ddd')
                                            .toUpperCase()}
                                    </span>
                                    <span className={classes.tripDateMonth}>
                                        {moment(extractDate(trip.date_svc))
                                            .format('Do MMM')
                                            .toUpperCase()}
                                    </span>
                                </div>
                            </div>
                            <div className={classes.tripService}>
                                {extractTime(trip.date_svc)} | {trip.s_name}
                                {'stop' in trip && (
                                    <div className={classes.tripStop}>
                                        <span className={classes.tripStopLabel}>
                                            {trip.stop}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </>
    );
};

export default withStyles(styles)(BookingTable);
